(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
ga('create', 'UA-50780056-1', 'hackthenorth.com');
ga('send', 'pageview', { 'page': location.pathname + location.search + location.hash});

var $facebookIcon = document.querySelector('.facebook-icon');
var $twitterIcon = document.querySelector('.twitter-icon');
var $anchors = document.querySelectorAll('.navbar-link, .menu-item');
var $footerLink = document.querySelector('.footer-contact a');

$facebookIcon.onclick = function (){
  ga('send', 'event', 'link', 'click', 'view-facebook');
}
$twitterIcon.onclick = function (){
  ga('send', 'event', 'link', 'click', 'view-twitter');
}

for (var i = 0; i < $anchors.length; i++) {
  if (!$anchors[i].hash){
    continue;
  }
  $anchors[i].onclick = (function (hash) {
    return function () {
      ga('send', 'pageview', location.pathname + hash);
    }
  })($anchors[i].hash);
}

$footerLink.onclick = function () {
  ga('send', 'event', 'link', 'click', 'footer-email');
}



/*****************
 ** WEBPACK FOOTER
 ** ./js/main/ga-tracking.js
 ** module id = 379
 ** module chunks = 2 4 5
 **/